import { render } from "./Index.vue?vue&type=template&id=2bf291b8"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "2bf291b8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2bf291b8', script)) {
    api.reload('2bf291b8', script)
  }
  
  module.hot.accept("./Index.vue?vue&type=template&id=2bf291b8", () => {
    api.rerender('2bf291b8', render)
  })

}

script.__file = "resources/js/Pages/Tour/Index.vue"

export default script